import { AnimatePresence, motion, useReducedMotion } from "motion/react";
import { memo, type ReactNode } from "react";
import * as css from "./intake-modal.module.css";

const STEP_TRANSITION_DISTANCE = 32;
const STEP_TRANSITION = { duration: 0.24, ease: "easeOut" } as const;

export const IntakeStepTransition = memo(function IntakeStepTransition({
  children,
  direction = 1,
  enabled = true,
  stepKey,
}: {
  children: ReactNode;
  direction?: number;
  enabled?: boolean;
  stepKey: string;
}) {
  const shouldReduceMotion = useReducedMotion();

  if (!enabled) {
    return <>{children}</>;
  }

  if (shouldReduceMotion) {
    return <div className={css.stepTransitionFrame}>{children}</div>;
  }

  return (
    <AnimatePresence custom={direction} mode="wait">
      <motion.div
        animate={{ opacity: 1, x: 0 }}
        className={css.stepTransitionFrame}
        custom={direction}
        exit={{
          opacity: 0,
          x:
            direction === 1
              ? -STEP_TRANSITION_DISTANCE
              : STEP_TRANSITION_DISTANCE,
        }}
        initial={{
          opacity: 0,
          x:
            direction === 1
              ? STEP_TRANSITION_DISTANCE
              : -STEP_TRANSITION_DISTANCE,
        }}
        key={stepKey}
        transition={STEP_TRANSITION}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
});
